import React from 'react';

interface StatisticsProps {
  counters: {
    projects: number;
    satisfaction: number;
    years: number;
    support: number;
  };
}

const Statistics: React.FC<StatisticsProps> = ({ counters }) => {
  const stats = [
    {
      value: `${counters.projects}+`,
      label: "Projects Completed",
      color: "text-brand-blue"
    },
    {
      value: `${counters.satisfaction}%`,
      label: "Client Satisfaction",
      color: "text-brand-orange"
    },
    {
      value: `${counters.years}+`,
      label: "Years Experience",
      color: "text-brand-blue"
    },
    {
      value: `${counters.support}/7`,
      label: "Support Available",
      color: "text-brand-orange"
    }
  ];

  return (
    <section className="section-padding bg-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-brand-orange/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-brand-blue/5 rounded-full blur-3xl"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">
            Our Impact in Numbers
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Delivering measurable results that drive business growth
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center group">
              <div className="bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 transform hover:scale-105">
                <div className={`text-5xl font-medium mb-2 group-hover:scale-110 transition-transform duration-300 ${stat.color}`}>
                  {stat.value}
                </div>
                <div className="text-gray-600 font-normal">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Statistics;
